import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=e9ada930"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/srv/app/components/button/Button.vue').default,Button: require('/srv/app/components/button/Button.vue').default})
